module.exports = __webpack_public_path__ + "static/media/notification.1ad87ed9.svg";